import React from 'react';
import _ from "lodash";
import '../../css/dynamicTable.css';

import HasColumnPrompt from './HasColumnPrompt';

import Tbody from './Tbody';
import Thead from './Thead';
import ColumnFilter from  './ColumnFilter';

import {filterColumns, orderColumns} from './ColumnViewUtil';

import columnViewIcon from '../../images/columnView.svg';
import columnViewBlueIcon from '../../images/columnViewBlue.svg';


/**
 * @author James Adams
 * @todo Investigate using react hooks for event emitters.
 */
class DynamicTable extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      "filterDisplay":"closed",
      "columnViewDisplay":"closed",
      "SelectedFilterColumn":null
    };

    //mixin
    HasColumnPrompt.call(this);
  }

  /**
   * Render the dynamic table.
   * @return {jsx}
   */
  render(){
    return (
      <React.Fragment>
        {this._renderTable()}
        <ColumnFilter
          filter={this.props.filter}
          updateFilter = {this.props.updateFilter}
          localState={this.state}
          updateLocalState={this._updateLocalState.bind(this)}
        />
        {this.renderColumnPrompt()}
      </React.Fragment>
    );
  }

  /**
   *
   */
  _renderTable(){
    if(this.props.pageCount !== undefined){
      return (
        <div className="dynTablePageScroller" onScroll={this._scrollTable.bind(this, this.props)}>
          {this._renderColumnViewIcon(this.props)}
          {this._renderDynamicPagingTable()}
        </div>
      );
    }else{
      return (
        <React.Fragment>
          {this._renderColumnViewIcon(this.props)}
          {this._renderDynamicTable()}
        </React.Fragment>
      );
    }
  }


  /**
   *
   */
  _renderDynamicPagingTable(){
    let captionNode= this._resolveCaption();
    let className="dynamicTable "+(this.props.tableClass||"");
    const {orderedColumns} = orderColumns(this.props.columns, this.props.columnOrder);
    const filteredColumns = filterColumns(
      orderedColumns,
      this.props.columnView
    );

    return (
      <table className={className}>
        {captionNode}
        <Thead
        columns={filteredColumns}
        columnSort={this._clickColumn.bind(this)}
        sort={this.props.sort}
        localState={this.state}
        updateLocalState={this._updateLocalState.bind(this)}
        filter={this.props.filter}
        filterIcon={this.props.filterIcon}
        filterSetIcon={this.props.filterSetIcon}
        />

        <Tbody
        filteredColumns = {filteredColumns}
        columnOrder = {this.props.columnOrder}
        columns={this.props.columns}
        render={this.props.render}
        rows={this.props.rows}
        sort={this.props.sort}

        selection={this.props.selection}
        rowSelect={this._clickRow.bind(this)}

        rowClassKey={this.props.rowClassKey}
        customSort={this.props.customSort}

        pageStart={this.props.pageStart}
        pageEnd={this.props.pageEnd}
        filter={this.props.filter}
        />
      </table>
    );
  }


  /**
   *
   */
  _renderColumnViewIcon(props){
    if(props.columnView){
      const keys = Object.keys(props.columnView);
      let icon = columnViewIcon;
      if(keys.length > 0){
        icon = columnViewBlueIcon;
      }
      return (
        <img
          alt="Change Viewed Columns"
          title="Change Viewed Columns"
          className="columnViewIcon"
          src={icon}
          onClick={this._openColumnViewer.bind(this, props)}
        />
      );
    }else{
      return null;
    }
  }


  /**
   *
   */
  _openColumnViewer(props){
    let state = _.cloneDeep(this.state);
    state.columnViewDisplay='open';
    state.SelectedFilterColumn=null;
    this.setState(state);
  }


  /**
   *
   */
  _updateLocalState(state){
    this.setState(state);
  }


  /**
   *
   */
  _renderDynamicTable(){
    let captionNode= this._resolveCaption();
    let className="dynamicTable "+(this.props.tableClass||"");
    const {orderedColumns} = orderColumns(this.props.columns, this.props.columnOrder);
    const filteredColumns = filterColumns(
      orderedColumns,
      this.props.columnView,
      this.props.columnOrder
    );

    return (
      <table className={className}>
        {captionNode}
        <Thead
        columns={filteredColumns}
        columnSort={this._clickColumn.bind(this)}
        sort={this.props.sort}
        localState={this.state}
        updateLocalState={this._updateLocalState.bind(this)}
        filter={this.props.filter}
        filterIcon={this.props.filterIcon}
        filterSetIcon={this.props.filterSetIcon}
        />

        <Tbody
        filteredColumns = {filteredColumns}
        columnOrder = {this.props.columnOrder}
        columns={this.props.columns}
        render={this.props.render}
        rows={this.props.rows}
        sort={this.props.sort}

        selection={this.props.selection}
        rowSelect={this._clickRow.bind(this)}

        rowClassKey={this.props.rowClassKey}
        customSort={this.props.customSort}
        filter={this.props.filter}
        />
      </table>
    );
  }


  /**
   * Resolve the caption node from a passed in property.
   * @returns {jsx} can return null
   */
  _resolveCaption(){
    let captionNode=null;
    if(this.props.caption){
      captionNode = (
        <caption>
          {this.props.caption}
        </caption>
      );
    }
    return captionNode;
  }


  /**
   *
   */
  _scrollTable(props, event){
    let element = event.target;
    let buffer = 200;
    let scrollPosition = element.scrollHeight - element.scrollTop;
    if (scrollPosition - buffer <= element.clientHeight) {
      this._pageLoad(props);
    }
  }


  /**
   * User clicks on a row.
   * If available calls the updateSelection callback.
   * @param {Event} event
   */
  _clickRow(event){
    let keyValue = event.target.parentElement.dataset.keyvalue;
    if(this.props.updateSelection){
      this.props.updateSelection(keyValue);
    }
  }


  /**
   *
   */
  _pageLoad(props){
    let start = props.pageStart;
    let end = props.pageEnd;

    end += props.pageCount;

    if(this.props.updatePage){
      this.props.updatePage(start,end);
    }
  }


  /**
   * User CLicks on a column.
   * @param {Event} event
   */
  _clickColumn(event){
    var sort = Object.assign({}, this.props.sort);
    let id = event.target.id;
    if(sort[id]===undefined){
      sort[id] = 'asc';
    }else if(sort[id] === 'asc'){
      sort[id] = 'desc';
    }else if(this.props.sort[id] === 'desc'){
      sort[id] = undefined;
    }
    this.props.updateSort(sort);
  };
}

export default DynamicTable;
